import React from 'react';

import { Paper } from '@mui/material';

const BiMetric = ({
    className = 'bi-ge-indications-metric',
    icon: Icon,
    label,
    subtitle,
    tone = 'amber',
    value
}) => {
    const metricClassName = [
        'bi-aluguel-access-metric',
        className,
        `is-${tone}`
    ].filter(Boolean).join(' ');

    return (
        <Paper className={metricClassName}>
            <span className='bi-aluguel-access-metric-icon'>
                <Icon fontSize='small' />
            </span>
            <span>{label}</span>
            <strong>{value}</strong>
            {subtitle && <small>{subtitle}</small>}
        </Paper>
    );
};

export default BiMetric;
